import './UINameEdit.css'
import { IconButton, Stack, TextField, Tooltip, Typography } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import DoneIcon from '@mui/icons-material/Done'
import ClearIcon from '@mui/icons-material/Clear'
import * as React from 'react'

type Props = {
  currentName: string
  toolTip: string
  updateName: Function
}

export default function UINameEdit({currentName, toolTip, updateName}: Props) {

  const [editing, setEditing] = React.useState(false)
  const [name, setName] = React.useState(currentName)

  function handleChangeName(event: React.ChangeEvent<HTMLInputElement>){
    setName(event.target.value)
  }

  function handleClickEdit() {
    setName(currentName)
    setEditing(true)
  }

  function handleClickDone() {
    updateName(name)
    setEditing(false)
  }

  function handleClickCancel() {
    setEditing(false)
  }

  function editOrShowName() {
    
    if (editing) {
      return (
        <Stack className='editing' direction={'row'} alignContent={'center'}>
          <input className='input'
            autoFocus
            value={name}
            onChange={handleChangeName}
            onBlur={handleClickDone}
            type='string'
          />
          <IconButton sx={{borderRadius: 0}} onClick={handleClickDone}>
            <DoneIcon/>
          </IconButton>
        </Stack>
      )
    } else {
      return (
        <Tooltip arrow placement={"top"} title={toolTip}>
          <div className={'pointer'} onClick={handleClickEdit}>
            <Typography variant='h4'>{currentName}</Typography>
          </div>
        </Tooltip>
      )
    }
  }


  return(
    <>
      {editOrShowName()}
    </>
  )
}